module.exports = __webpack_public_path__ + "static/006-6e9abc722c0f956733591b13d6dd7aaa.jpg";